// CustomerRow.jsx
import React, { useState } from 'react';
import Classes from './Invoices.module.css';

import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';

export default function TableRow({ value, index }) {

  return (
    <>
      <div
        className={`${Classes.customerRow} ${value.status === 'disabled' ? Classes.disabledRow : ''
          }`}
        key={value._id}
      >
        <div className={`${Classes.customerInfo} ${Classes.col1}`}>
          <input type='checkbox' />
        </div>

        <div className={`${Classes.bookings} ${Classes.col2}`}>
          <h5>{value.client}</h5>
        </div>

        <div className={`${Classes.dateJoined} ${Classes.col3}`}>
          <h5> {value.total} </h5>
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col4}`}>
          <DropDown
            selectedValue={value.status}
            options={["Paid", "Overdue"]}
            onChange={(val) => value.status = val}
            isDropDown={false}
          />
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col5}`}>
          <h5> {value.created} </h5>
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col6}`}>
          <h5> {value.paid} </h5>
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col7}`}>
          <h5> {value.number} </h5>
        </div>

        <div className={`${Classes.actions} ${Classes.col8}`}>
          <MoreDropDown
            index={index}
            user={value}
          />
        </div>
      </div>
    </>
  );
}


